<template>
  <div class="captail_wrap position-relative fullLoader registrationSteps p-0">
    <loader v-if="pageLoader"></loader>
    <div class="middle_section m-0 mobdesign">
      <div class="top_searchbars">
        <div class="col-12">
          <div class="cap_logo mob-text-center noBG">
            <router-link to="/home"
              ><img
                src="../../../../static/website/images/logo.svg"
                alt="Captail wallet"
            /></router-link>
          </div>
        </div>
      </div>
      <div
        class="mid_scroll_content d-flex align-items-center justify-content-center mt-custom"
      >
        <section class="stepsForm-include border-0 w-100">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-5 stepBorder box-shadow text-center">
              <h3 class="text-center incMob mb-3">Create  Password</h3>
              <p>Create a strong password and keep it secure.</p>
              <form class="mt-4" acttion="#">
                <div class="form-group">
                  <label class="labeltext">Create Password</label>
                  <div class="position-relative">
                    <input
                      placeholder=" "
                      :type="show_create_pass"
                      class="form-control"
                      v-model="password"
                      v-validate="{
                        required: true,
                        regex:
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*])\S{8,24}$/,
                      }"
                      :class="{
                        'is-invalid': submitted && errors.has('password'),
                      }"
                      name="password"
                    />
                    <password-icon
                      class="ico"
                      v-model="show_create_pass"
                    ></password-icon>
                  </div>
                  <p class="error" v-for="error in errors.collect('password')">
                    {{ error }}
                  </p>
                  <div class="successMessage-report mt-2">
                    <div class="charactersMessage">
                      <p class="mb-1">your password must include at least:</p>
                      <ul
                        class="flex-wrap d-flex justify-content-between align-items-center"
                      >
                        <li :class="testing('capital') ? 'text-success' : ''">
                          - 1 uppercase character
                        </li>
                        <li :class="testing('length') ? 'text-success' : ''">
                          - 8 or more characters
                        </li>
                        <li :class="testing('Number') ? 'text-success' : ''">
                          - Number
                        </li>
                        <li :class="testing('Letters') ? 'text-success' : ''">
                          - Letters
                        </li>
                        <li
                          :class="testing('Special_char') ? 'text-success' : ''"
                        >
                          - Special characters
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="labeltext">Confirm Password</label>
                  <div class="position-relative">
                    <input
                      placeholder=" "
                      :type="show_conf_pass"
                      class="form-control"
                      v-model="confirm_password"
                      v-validate="{ required: true, confirmed: password }"
                      :class="{
                        'is-invalid':
                          submitted && errors.has('confirm password'),
                      }"
                      name="confirm password"
                    />
                    <password-icon
                      class="ico"
                      v-model="show_conf_pass"
                    ></password-icon>
                  </div>
                  <p
                    class="error"
                    v-for="error in errors.collect('confirm password')"
                  >
                    {{ error }}
                  </p>
                </div>
                <alert-notification
                  v-if="notification_msg != ''"
                ></alert-notification>
                <div class="submitButton text-center mt-3 mt-md-5">
                  <input
                    type="button"
                    class="cap_btn blue px-4 large_btn"
                    value="Save & Continue"
                    :class="pageLoader ? 'disabled' : ''"
                    v-on:click.stop.prevent="submit"
                  />
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { Const } from "@/plugins/registerSteps/provider/lib/const.cls.ts";
import { registerStepsMixins } from "@/plugins/registerSteps";
/*
import { Validator } from 'vee-validate';
Validator.extend('falsy', {
  getMessage: field => 'The ' + field + " value not allow '&' Special character"  ,
  validate: value => !value.includes("&")
});*/
export default {
  name: "step-three",
  mixins: [registerStepsMixins],
  data() {
    return {
      password: "",
      confirm_password: "",
      pageLoader: false,
      notification_msg: "",
      notification_type: "",
      submitted: false,
      show_create_pass: "password",
      show_conf_pass: "password",
    };
  },
  methods: {
    testing(type) {
      var num = /[0-9]/g;
      var Lett = /[a-z A-Z]/g;
      var uppercase = /[A-Z]/g;
      var Special_char = /[!@#$%^*]/g;

      if (type == "length") {
        return this.password.length >= 8;
      } else if (type == "Number") {
        return num.test(this.password);
      } else if (type == "Letters") {
        return Lett.test(this.password);
      } else if (type == "Special_char") {
        return Special_char.test(this.password);
      } else if (type == "capital") {
        return uppercase.test(this.password);
      }
    },
    submit() {
      if (this.pageLoader) {
        return;
      }
      const _that = this;
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let input_json = {
            globalParams: {
              otp: _that.step3.otp,
              transaction_id: _that.step3.transaction_id,
              password: _that.password,
            },
            localParams: { parameter: _that },
          };
          if (localStorage.getItem("transfer_token")) {
            input_json.globalParams["api_query"] = {
              transfer: localStorage.getItem("transfer_token"),
            };
          }
          _that._runStep3(input_json);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("step3")) {
      this.$store.commit(
        Const.SET_STEP3,
        JSON.parse(localStorage.getItem("step3"))
      );
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/registerSteps/password_step.vue